import axios from 'axios'
import { REACT_APP_COTIZADOR_API } from '../../config'

export async function getVehicleSegments(companyId, filter) {
    const result = await axios.get(`${REACT_APP_COTIZADOR_API}/cotizador/v1/companySegments/vehicles?${filter}`, {
        params: {
          companyId
        },
      })
      return result;
}
